export default __webpack_public_path__ + "static/media/descarga.4fad67ad.jfif";